export const sleep = async (data, timeout) => {
  await new Promise((resolve) => setTimeout(resolve, timeout));

  return data;
};
